const SET_WARNING = 'warnings/SET_WARNING';
const REMOVE_WARNING = 'warnings/REMOVE_WARNING';
const CLEAN_WARNINGS = 'warnings/CLEAN_WARNINGS';

export default {
  SET_WARNING,
  REMOVE_WARNING,
  CLEAN_WARNINGS,
};
